// @flow
import { get } from "lodash";
import { DefaultRootState } from "react-redux";

export const getSplashIsOpen = (store: DefaultRootState) =>
  get(store, "locationSplash.isOpen", false);

export const getSplashIsLocationRequired = (store: DefaultRootState) =>
  get(store, "locationSplash.isLocationRequired", false);
